import React from 'react';
import {CURRENCIES, EXTENSION_DATA, ITEMS} from "./constants";
import Button from "./component/Button";
import OtherSettings from "./component/OtherSettings";
import HasAltin from "./component/HasAltin";
import empty from "./empty";
import Currency from "./component/Currency";
import Item from "./component/Item";

class SettingsScreen extends React.Component {

    state = {
        locked: true,
        loading: true,
        hasAltin: {alis: 0, satis: 0},
        prices: null,
        settings: empty,
        password: ''
    };

    componentDidMount() {
        this.fetchRemoteSettings();
    }

    changeSettings = (key, value) => {
        this.setState({settings: {...this.state.settings, [key]: value}})
    };

    fetchRemoteSettings = () => {
        fetch('/api/', {
            headers: {
                //'secret-key': '$2a$10$ok4EdRvKIUWUkMOPNZ/GguO79EgsMb6oNII6wsGtL8NQNAVtMeR8C',
                'Content-Type': 'application/json'
            },
        }).then((response) => {
            return response.json();
        }).then((res) => {
            this.setState({...res, hasAltin: res.prices.altin, loading: false});
            window.prices = res.prices;
        }).catch((err) => {
            window.alert('BİR HATA OLUŞTU !!! Ayarlar alınamadı.');
            console.log(err)
        });
    };

    saveRemoteSettings = () => {
        if (this.state.password.length <= 0) {
            alert('Lütfen parolayı giriniz.');
            return;
        }
        if (window.confirm("Ayarlarınız paylaşılacak. Emin misiniz?")) {

            fetch('/api/', {
                method: 'POST',
                headers: {
                    'secret-key': this.state.password,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.state.settings),
            }).then((response) => {
                if (response.status === 401) {
                    throw response;
                }
                return response.json();
            }).then((res) => {
                window.alert('Ayarlar Kaydedildi.')
            }).catch((err) => {
                if (err.status === 401) {
                    window.alert('Parola Hatalı! Ayarlarınız kaydedilemedi.');
                } else {
                    window.alert('BİR HATA OLUŞTU !!! Ayarlar kaydedilemedi.')
                }
            });
        }
    };

    renderSaveButton = () => {
        return (
            <div className="box">
                <table style={{width: '100%'}}>
                    <td style={{width: '40%'}}>
                        <input type="password" className="pw_input" placeholder="Kaydetmek için Parolayı Giriniz" value={this.state.password} onChange={(e) => this.setState({password: e.target.value})}/>
                    </td>
                    <td style={{width: '10%'}}/>
                    <td>
                        <Button onClick={this.saveRemoteSettings} title="Ayarları Kaydet"/>
                    </td>
                </table>
            </div>
        )
    };

    render() {
        const {settings, hasAltin} = this.state;

        if (this.state.loading) {
            return null;
        }

        return (
            <React.Fragment>
                {this.renderSaveButton()}

                <OtherSettings settings={settings.settings} onChange={(val) => this.changeSettings('settings', val)}/>

                <HasAltin data={settings} hasAltin={hasAltin} onChange={(val) => {
                    this.changeSettings('has_altin', val)
                }}/>

                {CURRENCIES.map((currency) => {
                    return <Currency title={currency.title} name={currency.name} data={settings} onChange={(val) => {
                        this.changeSettings(currency.name, val)
                    }}/>
                })}

                {ITEMS.map((item) => {
                    return <Item key={item.name} title={item.title} name={item.name} data={settings} hasAltin={hasAltin} onChange={(val) => {
                        this.changeSettings(item.name, val)
                    }}/>
                })}
            </React.Fragment>
        )
    }
}

export default SettingsScreen


// WEBPACK FOOTER //
// ./src/SettingsScreen.js